<template>
    <div>
        <b-card no-body v-show="mostrarMensagens">
            <b-card-header>
                <h5>
                    MENSAGENS
                    <b-button
                        variant="success"
                        class="float-right mr-2"
                        @click.stop="novaConversa()"
                    >
                        <i class="fa fa-plus mr-2"></i>Nova Conversa
                    </b-button>
                </h5>
            </b-card-header>
            <b-card-body>
                <b-tabs card v-model="activeTab">
                    <b-tab class="pb-0">
                        <template v-slot:title>
                            <h5>
                                Recebidas
                                <b-badge variant="primary">{{
                                    mensagens.qtdMensagensNaoLidas
                                }}</b-badge>
                            </h5>
                        </template>
                        <recebidas
                            v-show="activeTab === 0"
                            ref="recebidas"
                            :usuario-id="usuarioLogado.id"
                            :usuario="usuarioLogado.nome"
                            :deve-carregar="activeTab === 0 || needsRecebidaUpdate"
                            @novas-mensagens="atualizarContadorNovasMensagens"
                        />
                    </b-tab>
                    <b-tab>
                        <template v-slot:title>
                            <h5>Enviadas</h5>
                        </template>
                        <enviadas 
                            v-if="activeTab === 1"
                            ref="enviadas"
                            :usuario-id="usuarioLogado.id"
                            :usuario="usuarioLogado.nome"
                            :deve-carregar="activeTab === 1"
                        ></enviadas>
                    </b-tab>
                    <!-- <b-tab>
                        <template v-slot:title>
                            <h5>Rascunhos</h5>
                        </template>
                        <rascunhos
                            :mensagens="mensagens.rascunhos"
                            @obterMensagensAtualizadas="obterMensagens()"
                        >
                        </rascunhos>
                    </b-tab> -->
                    <b-tab>
                        <template v-slot:title>
                            <h5>Conversas</h5>
                        </template>
                        <conversas 
                            v-if="activeTab === 2"
                            ref="conversas"
                            :usuario-id="usuarioLogado.id"
                            :usuario="usuarioLogado.nome"
                            :deve-carregar="activeTab === 2"
                        ></conversas>
                    </b-tab>
                </b-tabs>
            </b-card-body>
        </b-card>
        <router-view
            @obterMensagensEConversasAtualizadas="obterConversas()"
        ></router-view>
    </div>
</template>

<script>
import Recebidas from './Recebidas'
import Enviadas from './Enviadas'
// import Rascunhos from './Rascunhos'
import Conversas from './Conversas'
import { conversasHub } from './ConversasHub'

export default {
    components: {
        Recebidas,
        Enviadas,
        // Rascunhos,
        Conversas
    },

    data() {
        return {
            activeTab: 0,
            mensagens: {
                qtdMensagensNaoLidas: 0
            },
            conversas: { conversas: [] },
            usuarioLogado: {
                id: '',
                nome: ''
            },
            // Flags para indicar se as abas precisam ser atualizadas quando ficarem ativas
            needsRecebidaUpdate: false,
            needsEnviadasUpdate: false,
            needsConversasUpdate: false
        }
    },

    async mounted() {
        // Conecta o hub UMA ÚNICA VEZ no painel principal
        const fornecedorId = this.$store.getters.fornecedor?.fornecedorId || null
        await conversasHub.conectar(this.$store.getters.usuario.usuarioId, fornecedorId)
        
        // Registra eventos globais do painel
        conversasHub.on('NovaConversaRecebida', this.onNovaConversaRecebida)
        conversasHub.on('NovaConversaEnviada', this.onNovaConversaEnviada)
        conversasHub.on('NovaMensagemRecebida', this.onNovaMensagemRecebida)
    },

    async created() {
        await this.obterUsuario()
    },

    beforeDestroy() {
        conversasHub.desconectar()
    },

    watch: {
        activeTab(newTab, oldTab) {
            this.$nextTick(() => {
                if (newTab === 0 && this.needsRecebidaUpdate && this.$refs.recebidas) {
                    this.$refs.recebidas.carregarConversas()
                    this.needsRecebidaUpdate = false
                }
                
                if (newTab === 1 && this.needsEnviadasUpdate && this.$refs.enviadas) {
                    this.$refs.enviadas.carregarConversas()
                    this.needsEnviadasUpdate = false
                }
                
                if (newTab === 2 && this.needsConversasUpdate && this.$refs.conversas) {
                    this.$refs.conversas.carregarConversas()
                    this.needsConversasUpdate = false
                }
            })
        }
    },

    methods: {
        onNovaConversaRecebida() {
            // Apenas atualiza as abas que estão ativas, não força carregamento em todas
            if (this.activeTab === 0 && this.$refs.recebidas) {
                this.$refs.recebidas.carregarConversas()
            }
            if (this.activeTab === 2 && this.$refs.conversas) {
                this.$refs.conversas.carregarConversas()
            }
        },

        onNovaConversaEnviada() {
            // Apenas atualiza as abas que estão ativas
            if (this.activeTab === 1 && this.$refs.enviadas) {
                this.$refs.enviadas.carregarConversas()
            }
            if (this.activeTab === 2 && this.$refs.conversas) {
                this.$refs.conversas.carregarConversas()
            }
        },

        onNovaMensagemRecebida(dados) {
            // Força atualização apenas das flags, não chama carregarConversas() imediatamente
            this.needsRecebidaUpdate = true
            this.needsEnviadasUpdate = true
            this.needsConversasUpdate = true
            
            // Atualiza APENAS a aba "Recebidas" sempre (para o contador)
            if (this.$refs.recebidas) {
                this.$refs.recebidas.carregarConversas()
                this.needsRecebidaUpdate = false
            }
        },

        atualizarContadorNovasMensagens(quantidade) {
            this.$set(this.mensagens, 'qtdMensagensNaoLidas', quantidade)
            this.$store.commit('SET_QTD_MENSAGENS_NAO_LIDAS', quantidade)
        },

        async obterConversas() {
            switch(this.activeTab) {
                case 0:
                    if (this.$refs.recebidas) {
                        await this.$refs.recebidas.carregarConversas()
                    }
                    break
                case 1:
                    if (this.$refs.enviadas) {
                        await this.$refs.enviadas.carregarConversas()
                    }
                    break
                case 2:
                    if (this.$refs.conversas) {
                        await this.$refs.conversas.carregarConversas()
                    }
                    break
            }
        },

        async novaConversa() {
            this.$router.push({
                name: 'Conversa_Inserir'
            })
        },

        async obterUsuario() {
            this.usuarioLogado.id = this.$store.getters.usuario.usuarioId
            this.usuarioLogado.nome = this.$store.getters.usuario.nome
        }
    },

    computed: {
        mostrarMensagens() {
            return this.$route.name == 'Mensagens'
        }
    }
}
</script>
